import React, { useState, useEffect } from 'react';
import { supabase } from "../../supabaseClient";

export default function CompanyList() {
  const [companies, setCompanies] = useState([]);

  const fetchCompanies = async () => {
    const { data, error: sessionsError } = await supabase
      .from('companies')
      .select(`*`);

    if (sessionsError) {
      console.error('Error fetching copaanies:', sessionsError);
    } else {
      setCompanies(data);
    }
  };
  useEffect(() => {
    fetchCompanies();
  }, []);

  return (
    <div>
      {companies && companies.map((company) => (
        <div
          key={company.id}
          style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: '10px'
          }}
        >
          <div style={{
            width: '20px',
            height: '20px',
            borderRadius: '50%',
            backgroundColor: company.color,
            marginRight: '10px',
          }} />
          <span>{company.name}</span>
        </div>
      ))}
    </div>
  );
};